export default __webpack_public_path__ + "static/media/dryer.e67d0921.svg";